/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

export const Root = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',

  [`${theme.breakpoints.down('md')}`]: {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));
